export default __webpack_public_path__ + "static/media/coins.08d79426.png";